import { cloneElement, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Drawer from "@mui/material/Drawer";
import { MenuOutlined, Close } from "@mui/icons-material";
import "./Header.css";

const NAV_ITEMS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  // { name: "Scientific Schedule", path: "/scientific-schedule" },
  { name: "Healthcare Education", path: "/healthcare-education" },
  { name: "Cases", path: "/cases" },
  { name: "Events", path: "/events" },
  { name: "Contact", path: "/contact" },
];

function ElevationScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}

const Header = (props) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawerContent = (
    <div className="drawer-container">
      <div className="drawer-header">
        {/* Fixed Logo Structure for Drawer */}
        <div
          className="logo-container"
          onClick={() => {
            navigate("/");
            handleDrawerToggle();
          }}>
          <img src="/scope/logo.png" alt="Logo" className="logo-img" />
        </div>
        <Close onClick={handleDrawerToggle} className="close-icon" />
      </div>
      <div className="drawer-nav-list">
        {NAV_ITEMS.map((item) => (
          <div
            key={item.name}
            className={`drawer-item ${location.pathname === item.path ? "active" : ""}`}
            onClick={() => {
              navigate(item.path);
              handleDrawerToggle();
            }}>
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <ElevationScroll {...props}>
        <AppBar position="fixed" className="app-bar">
          <Toolbar className="toolbar-container">
            {/* Fixed Logo Structure for Desktop */}
            <Link to="/" className="logo-container">
              <img src="/scope/logo.png" alt="Logo" className="logo-img" />
              <div className="logo-text-block">
                <span className="logo-org-name">Society for Clinical Oncology</span>
                <span className="logo-org-name">and Pathology Education</span>
              </div>
            </Link>

            {/* DESKTOP NAVIGATION */}
            <div className="desktop-nav">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`nav-link ${location.pathname === item.path ? "active" : ""}`}>
                  {item.name}
                </Link>
              ))}
            </div>

            {/* MOBILE ROUTE LABEL */}
            <div className="mobile-route-label">
              {NAV_ITEMS.find((item) => item.path === location.pathname)?.name ?? "Menu"}
            </div>

            {/* MOBILE MENU ICON */}
            <div className="mobile-menu-icon" onClick={handleDrawerToggle}>
              <MenuOutlined fontSize="large" style={{ color: "var(--primary-blue)" }} />
            </div>
          </Toolbar>
        </AppBar>
      </ElevationScroll>

      {/* MOBILE DRAWER */}
      <Drawer anchor="right" open={mobileOpen} onClose={handleDrawerToggle} ModalProps={{ keepMounted: true }}>
        {drawerContent}
      </Drawer>

      <div className="header-spacer"></div>
    </>
  );
};

export default Header;
